export default __webpack_public_path__ + "static/media/Shin-straps of the Blood God (nm).a11cdcf1.jpg";